module.exports = __webpack_public_path__ + "static/media/loading-animation.cb10963f.svg";